import { useCallback, useEffect, useState } from "react";

/* Local replacement for the unpublished "use-in-view" package.
 * Returns [ref, inView]; inView becomes true once the element is `offset` px inside the viewport and stays true.
 */
export default function useInView(offset = 0) {
  const [node, setNode] = useState(null);
  const [inView, setInView] = useState(false);
  const ref = useCallback(el => setNode(el), []);

  useEffect(() => {
    if (!node || inView) return;

    if (typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { rootMargin: `0px 0px -${offset}px 0px` }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, inView, offset]);

  return [ref, inView];
}
